<script lang="ts">
    import AlternativeLabelsEditorPage from '@Alternatives/AlternativesLists/Pages/AlternativeLabelsEditorPage'
    export default AlternativeLabelsEditorPage
</script>

<template>
    <div>

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <form @submit.prevent="handleUpdateAlternativeLabelsCommand">

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Edit labels</h1>
                </div>
                <div class="col-lg-6 text-right">
                    <button type="submit" class="btn btn-success" style="padding: 0.7em 2em;">Save changes</button>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 60px;" />

        <div class="container" v-if="rm">

            <div class="shadow-none p-3 mb-3 bg-light rounded">
                <p><strong>You can replace the word “alternative” with a more relevant word like “car” or “vendor”.</strong></p>
                <p>
                    “Alternatives” is the word decision scientists use to describe the things you are choosing between.
                    Chances are, you’re not a decision scientist and you’re trying to choose between real-world “things” like cars, the potential sites of a new warehouse or a vendor.
                </p>
            </div>


            <div class="form-group">
                <label>Single alternative:</label>
                <input type="text" v-model.trim="rm.AlternativeLabel" class="form-control" required minlength="2">
                <small class="text-muted">What word would you like to use when talking about just one “alternative”?</small>
            </div>
            <div class="form-group">
                <label>Multiple alternatives:</label>
                <input type="text" v-model.trim="rm.AlternativesLabel" class="form-control" required minlength="2">
                <small  class="text-muted">What word would you like us to use for more than one “alternative”?</small>
            </div>
            
        </div>
        </form>


    </div>
</template>

<style scoped>

</style>


